import { useLang } from '@/i18n';
import EfCardsA from '@elem/ui/ef-cards-a';
import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.ListC');
    const listA = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1723021160177/Frame%201000008616.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1723021301700/Frame%201000008706.png',
            title: t('a_title'),
            desc: t('a_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1723021217783/Frame%201000008617.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1723021301700/Frame%201000008706.png',
            title: t('b_title'),
            desc: t('b_desc'),
        },
    ];
    return (
        <div className={styles.TheComp}>
            <EfCardsA list={listA} />
            <EfSpec className="ListC-spec1" />
        </div>
    );
}
